import type { RevisionReusableContent } from '../types';

/**
 * Quick compare two reusable content.
 * Return true if different.
 */
export function compareReusableContents(
    f1: RevisionReusableContent,
    f2: RevisionReusableContent
): boolean {
    return f1.document !== f2.document || f1.title !== f2.title || f1.id !== f2.id;
}
